import { AccountModule } from '@/store/modules/account';
import moment, { Moment } from 'moment';
import storage from './storage';
import { v4 as uuidv4 } from 'uuid';
import FileSaver from 'file-saver';
import XLSX from 'xlsx';
import CryptoJS from 'crypto-js';

const SECRETKEY = 'luckyPMSecretkey';
export interface ISearchTag {
  key: string;
  val: string;
}

export const isCurrentAccountByName = (name: string): boolean => {
  return AccountModule.name === name;
};
export const generateUUID = (): string => {
  return uuidv4();
};

// 传入本地时间字符串, 返回秒数
export const computeFromNowMillisecond = (timeStr: string): number => {
  return moment().unix() - moment(timeStr).unix();
};

// 世界标准时间与本地时间的偏移时间
export const getUtcOffset = (): number => {
  return moment().utcOffset();
};

// 世界标准时间转本地时间
export const utcTimeConvertLocalTime = (utcTimeStr: string): Moment => {
  const utcOffset = getUtcOffset();
  return moment.utc(utcTimeStr).add(utcOffset, 'm');
};

export const formatTimeStr = (timeStr: string, formatStr: string = 'YYYY-MM-DD'): string => {
  return moment(timeStr).format(formatStr);
};

export const timeFormat = (timeJsonStr: string, formatStr: string = 'YYYY-MM-DD HH:mm'): string => {
  if (!timeJsonStr) {
    return 'Now';
  }
  return utcTimeConvertLocalTime(timeJsonStr).format(formatStr);
};

export const getLanguage = (): string => {
  return storage.localGet('language');
};
export const setLanguage = (language: string) => {
  return storage.localSet('language', language);
};

export const compareObj = (objA: any, objB: any): boolean => {
  return JSON.stringify(objA) === JSON.stringify(objB);
};

export const searchParamsConvertArray = (obj: any): ISearchTag[] => {
  const resultArray: ISearchTag[] = [];
  Object.keys(obj).forEach((key) => {
    resultArray.push({
      key,
      val: obj[key],
    });
  });
  return resultArray;
};

export const disabledDate = (current: Moment) => {
  return current && current < moment().startOf('day');
};

export const saveAs = (data: Blob | string, filename?: string, options?: {autoBom: boolean}) => {
  FileSaver.saveAs(data, filename, options);
};
export const exportExcelByArray = (fileName: string, thead: string[], tbodyData: any[][]) => {
  const workbook = XLSX.utils.book_new();
  const ws = XLSX.utils.aoa_to_sheet([thead, ...tbodyData]);
  XLSX.utils.book_append_sheet(workbook, ws, 'Sheet1');
  const wbout = XLSX.write(workbook, { bookType: 'xlsx', bookSST: true, type: 'array' });
  try {
    saveAs(new Blob([wbout], { type: 'application/octet-stream' }), fileName);
  } catch (error) {
    throw error;
  }
};

export const isOverTime = (momentTime: Moment | null, minu: number): boolean => {
  if (!momentTime) {
    return true;
  }
  return moment().diff(momentTime, 'm') > minu;
};

// 计算表格跨行数
export const calculateTableRowSpan = <T>(
  row: T,
  data: T[],
  key: keyof T,
  index: number,
) => {
  // 判断上一行该列数据是否一样
  if (index !== 0 && data[index - 1] && row[key] === data[index - 1][key]) {
    return 0;
  }
  let rowSpan = 1;
  for (let i = index + 1; i < data.length; i++) {
    if (row[key] !== data[i][key]) {
      break;
    }
    rowSpan++;
  }
  return rowSpan;
};
export const mapToObj = <T>(map: Map<string, T>): {[propName: string]: T} => {
  const obj = Object.create(null);
  for (const [key, value] of map) {
    obj[key] = value;
  }
  return obj;
};

export function aesEncrypt(data: string) {
  return CryptoJS.AES.encrypt(data, SECRETKEY).toString();
}
export function aesDecrypt(encrypted: string) {
  return CryptoJS.AES.decrypt(encrypted, SECRETKEY).toString(CryptoJS.enc.Utf8);
}
